import React from 'react';

interface LogoLoadingProps {
  size?: number;
  className?: string;
}

export const LogoLoading: React.FC<LogoLoadingProps> = ({ 
  size = 80, 
  className = '' 
}) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 1080 1080"
        className="animate-pulse"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <style>
            {`
              .cls-1 { fill: #c8e600; }
              .cls-2 { fill: #ff4a8f; }
              .cls-3 { fill: #3b65f5; }
              
              .loading-animation {
                animation: logoFloat 2s ease-in-out infinite;
              }
              
              .loading-animation-2 {
                animation: logoFloat 2s ease-in-out infinite 0.3s;
              }
              
              .loading-animation-3 {
                animation: logoFloat 2s ease-in-out infinite 0.6s;
              }
              
              @keyframes logoFloat {
                0%, 100% { 
                  transform: translateY(0px) scale(1);
                  opacity: 1;
                }
                50% { 
                  transform: translateY(-10px) scale(1.05);
                  opacity: 0.8;
                }
              }
            `}
          </style>
        </defs>
        
        {/* Forma verde */}
        <g className="loading-animation">
          <path 
            className="cls-1" 
            d="M454.11,1004.63c-.1-174.56,139.37-316.05,311.51-316.25,172.8-.2,313.13,141.13,311.87,315.89l-623.38.36Z"
          />
        </g>
        
        {/* Forma azul */}
        <g className="loading-animation-2">
          <path 
            className="cls-3" 
            d="M322.67,424.94c147.88,88.11,196.34,279.42,108.23,427.3-88.11,147.88-280.52,195.75-428.4,107.64L322.67,424.94Z"
          />
        </g>
        
        {/* Forma rosa */}
        <g className="loading-animation-3">
          <path 
            className="cls-2" 
            d="M895.26,610.25c-147.65,88.49-339.09,40.53-427.58-107.12-88.49-147.65-40.25-339.27,107.4-427.76l320.18,534.88Z"
          />
        </g>
      </svg>
    </div>
  );
};
